// extracted by mini-css-extract-plugin
export default {"spacingText":"BirthDate_spacingText__3qPNn"};